module.exports = __webpack_public_path__ + "img/bulk-send-help-video.395a5b5b.png";